var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #2b2e45;\n      }\n\n      .cls-1 {\n        opacity: 0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18847",
    "data-name": "Rectangle 18847",
    className: "cls-1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7413",
    "data-name": "Path 7413",
    className: "cls-2",
    d: "M19,5H5A3,3,0,0,0,2,8v8a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V8A3,3,0,0,0,19,5ZM11,15H7a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Zm6,0H15a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm3-6H4V8A1,1,0,0,1,5,7H19a1,1,0,0,1,1,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.b8b8314a9d32f820b822b15f839e84bd.svg";
export { ForwardRef as ReactComponent };